// window.kinougarde_tracking_event = function(category, action, label) {
//     if (typeof dataLayer !== 'undefined') {
//         dataLayer.push({
//             'event'         : 'uaevent',
//             'eventCategory' : category,
//             'eventAction'   : action,
//             'eventLabel'    : label
//         });

//         // console.log(dataLayer);
//     }
// };

// window.kinougarde_tracking = function(data)
// {
//     if (typeof dataLayer !== 'undefined') {
//         dataLayer.push(data);
//     }
// };

jQuery(function() {
    //var $body = $(document.body);
    //----------  Custom track  ----------
    // $(document.body).on('click', '*[data-trackevent]', function(ev){
    //     var $target        = $(ev.currentTarget),
    //         trackCategory  = $target.data('kinougarde_trackcategory'),
    //         trackAction    = $target.data('kinougarde_trackaction'),
    //         trackLabel     = $target.data('kinougarde_tracklabel');

    //     kinougarde_tracking_event(trackCategory, trackAction, trackLabel);
    // });

    
    // Tracking Analytics KPInsight

    // Tracking bouton "Tarif pour mon enfant" et "Simulation budgétaire"
    $('a[href="'+ document.location.origin+'/simulation-budgetaire/"],a[href="/simulation-budgetaire/"]').on('click',function() {
        var menu = $(this).closest("#menu-panel").length>0;
        Kinougarde.TagManagerTunnel('SimulationBudgetaire/step-0',{'data-tracking-kpi':'famille-simulation-budgetaire-tarif-cta','data-tracking-menu' : menu});            
    });
    // Tracking bouton "Voir les nounou", "Je cherche une nounou", "Nounou près de chez moi"
    $('a[href="'+ document.location.origin+'/nounous-pres-de-chez-moi/"],a[href="/nounous-pres-de-chez-moi/"]').on('click',function() {
        var menu = $(this).closest("#menu-panel").length>0;
        Kinougarde.TagManagerTunnel('TrouverNounou/step-0',{'data-tracking-kpi':'famille-voir-nounou-pres-de-chez-moi-cta','data-tracking-menu' : menu});            
    });

    // Tracking bouton "Postuler" 
    $('a[href="'+ document.location.origin+'/postuler/"],a[href="/postuler/"]').on('click',function() {
        var menu = $(this).closest("#menu-panel").length>0;
        Kinougarde.TagManagerTunnel('Postuler/step-0',{'data-tracking-kpi':'intervenant-postuler-cta','data-tracking-menu' : menu});            
    });
    
    
    $("#section-home-recherche-nounou-form,#section-recherche-nounou-form,#section-recherche-nounou-no-image-form").attr("data-step-kpi","TrouverNounou/step-0");   
    $("#section-home-recherche-offres-form,#section-recherche-offres-form").attr("data-step-kpi","Offres/step-0");
    
    $("#section-home-recherche-offres-form").attr("data-step-kpi","Offres/step-0");
    // Début tunnel nounou
    $("#section-home-recherche-nounou-form #adresse,#section-recherche-nounou-form #adresse,#section-recherche-nounou-no-image-form #adresse").on('focus', function(e) {
        Kinougarde.TagManagerTunnel('TrouverNounou/step-0',{'data-tracking-kpi':'famille-recherche-nounou-champ-adresse-ville-cp'});            
    })
    $("#section-home-recherche-nounou-form #btn_adresse,#section-recherche-nounou-form #btn_adresse,#section-recherche-nounou-no-image-form #btn_adresse").on('click', function(e) {
        Kinougarde.TagManagerTunnel('TrouverNounou/step-0',{'data-tracking-kpi':'famille-recherche-nounou-trouver-submit'});            
    })
    // Debut tunnel offres
    $("#section-home-recherche-offres-form #adresse,#section-recherche-offres-form #adresse").on('focus', function(e) {
        Kinougarde.TagManagerTunnel('Offres/step-0',{'data-tracking-kpi':'intervenant-recherche-offres-champ-adresse-ville-cp'});            
    })
    $("#section-home-recherche-offres-form #btn_adresse,#section-recherche-offres-form #btn_adresse").on('click', function(e) {
        Kinougarde.TagManagerTunnel('Offres/step-0',{'data-tracking-kpi':'intervenant-recherche-offres-trouver-submit'});            
    })

    // L'Agence est chargée de manière asynchrone
    $(document).on('agence-loaded',function(e,agence) {
        try {
        dataLayer.push({agence : agence.name});
        } catch(e) {}
    });

    
    /** Taggage Analytics pour le Tunnel Postuler */
    $(document).on('data-step-kpi', function(e,step) {
        if (step==='Postuler/step-5') {
            // Fin du tunnel Postuler = Début du tunnel PostulerComplet                
            Kinougarde.TagManagerTunnel('PostulerComplet/step-1');
            
        }
    })

    /** Taggage Analytics sur erreur  */
    window.Parsley.on('form:error', function (formInstance) {
        var $form = $(formInstance.$element);
        var firstErrorElement = $form.find('.parsley-errors-list li:first');
        // Tracking des erreurs dans les formulaires
        if ($(".owl-item.active .step-form[data-step-kpi]").length>0) {
            step =  $(".owl-item.active .step-form[data-step-kpi]").data("step-kpi");
        } else {
            step = $form.data("step-kpi");
        }
        Kinougarde.TagManagerTunnel(step,{'event': 'GTMerror', 'ErrorType' : firstErrorElement[0].innerText,'url' : document.location.pathname});        
    })

    

});

